module.exports = __webpack_public_path__ + "img/partner4.b7a73700.png";